import { z } from "zod";
import { IdSchema, IsoDateSchema, IsoDateTimeSchema } from "./common.js";

/**
 * 달력·일정 (harness/API-SPEC.md §2-5).
 *
 * 일정(`Schedule`)은 사람이 적는 것이고, 사건(`CalendarEvent`)은 케이스·출고에서 **읽어
 * 오는** 것이다. 입고일·출고일을 일정으로 다시 적지 않는다 — 두 곳에 적으면 갈라진다.
 */
export const ScheduleSchema = z.object({
  id: IdSchema,
  on_date: IsoDateSchema,
  title: z.string().min(1),
  body: z.string().nullable(),
  case_id: IdSchema.nullable(),
  /** 화면은 케이스를 번호로 부른다 (C54) */
  case_no: z.string().nullable(),
  created_by: IdSchema.nullable(),
  created_at: IsoDateTimeSchema,
});
export type Schedule = z.infer<typeof ScheduleSchema>;

export const ScheduleCreateRequestSchema = z.object({
  on_date: IsoDateSchema,
  title: z.string().trim().min(1).max(120),
  body: z.string().trim().max(2000).optional(),
  case_id: IdSchema.optional(),
});
export type ScheduleCreateRequest = z.infer<typeof ScheduleCreateRequestSchema>;

export const ScheduleListQuerySchema = z.object({
  from: IsoDateSchema,
  to: IsoDateSchema,
});
export type ScheduleListQuery = z.infer<typeof ScheduleListQuerySchema>;

export const CALENDAR_EVENT_KINDS = ["received", "shipped_vendor", "shipped_owner", "swapped"] as const;

export const CalendarEventSchema = z.object({
  on_date: IsoDateSchema,
  kind: z.enum(CALENDAR_EVENT_KINDS),
  case_id: IdSchema,
  case_no: z.string(),
  serial_norm: z.string(),
  /** 입고면 보낸 회사, 출고면 받는 회사 */
  company: z.string().nullable(),
});
export type CalendarEvent = z.infer<typeof CalendarEventSchema>;

export const ScheduleListResponseSchema = z.object({
  from: IsoDateSchema,
  to: IsoDateSchema,
  items: z.array(ScheduleSchema),
  events: z.array(CalendarEventSchema),
});
export type ScheduleListResponse = z.infer<typeof ScheduleListResponseSchema>;
